import { getTestImpactScorelementId } from '@upright/test-ids/dom-elements';
import styled from 'styled-components';
import { BouColor } from '../../../../../../../../../generic/global/bou-colors';
import { useImpactChartContext, useImpactChartFontSizes, useImpactChartWidths } from '../../../../context';
import { plusIfPositive } from '../../../../shared';
import { formatImpactScore } from '../../../../value-formatter';
import { MiddlePartProps } from './types';

const Text = styled.text`
  fill: ${BouColor.BLACK};
  text-anchor: middle;
`;

export function ImpactRowMiddlePart(props: MiddlePartProps) {
  const widths = useImpactChartWidths();
  const { desktopMode, formatters, scoreType, scoreReaders } = useImpactChartContext();
  const { impactNetScores: fontSize } = useImpactChartFontSizes();

  const scoreReader = scoreReaders[props.index];
  const total = scoreReader.readScore(props.impactCode, undefined, undefined, undefined);
  if (!total) {
    return <g />;
  }

  const x = desktopMode
    ? widths.title + widths.bars + widths.middle / 2
    : widths.title + widths.bars + widths.middle - 16;
  const textAnchor = desktopMode ? 'middle' : 'end';
  const textX = desktopMode ? 0 : -20;

  const value = formatImpactScore(total, formatters, scoreType);
  const roundedValue = parseFloat(value);
  const color =
    roundedValue > 0
      ? BouColor.IMPACT_POSITIVE_GREEN
      : roundedValue < 0
        ? BouColor.IMPACT_NEGATIVE_PURPLE
        : BouColor.IMPACT_NEUTRAL_GRAY;

  return (
    <g transform={`translate(${x}, 0)`}>
      <Text id={getTestImpactScorelementId(props.impactCode)} dy="0.35em" x={textX} style={{ textAnchor, fontSize }}>
        {plusIfPositive(total)}
        {value}
      </Text>
      {!desktopMode && <rect width={10} height={10} x={textX + 10} y={-10 / 2} fill={color} />}
    </g>
  );
}
